import Vue from 'vue'
(function(owner){
	var isIE = window.ActiveXObject !== undefined;
	var CertMgr = null;
	var recipientCerts = new Array();
	var cert = null;
	var signCert = null;
	var cryptCert = null;
	var util = null;
	var pkcs7 = null;
	//非IE浏览器下
	var socket = null;
	var host = "ws://localhost:17212/test";
	window.onload = function(){
		if(isIE){// 创建WebSeal对象
			CertMgr = new HebcaP11Object();
		}else{
			connect();
		}
	};


	function HebcaP11Object(){
		var p11Ctrl = null;
		// 一个页面只创建一次
		if (null != CertMgr){
			return CertMgr;
		}
		if (isIE){
			// IE 浏览器创建插件
			try{
				var plugin_embed = document.createElement("OBJECT"); 
				plugin_embed.setAttribute("id", "npHebcaP11Plugin");  
				plugin_embed.setAttribute("classid", "CLSID:59B3BFD5-6CC5-4FFA-90E8-C1E5AFCB42E9");
				document.body.appendChild(plugin_embed);
						p11Ctrl = document.getElementById("npHebcaP11Plugin");
			
						npHebcaP11Plugin.Licence = "amViY56Xmp2cnpeanZyel5qdnJ6Xmp2cYWhlYoQsftgudcLw21NcfvO8eN13ICbS";
						
						util = npHebcaP11Plugin.Util;
						pkcs7 = npHebcaP11Plugin.CreatePkcs7();
			}
			catch(e){
				throw Error("没有安装客户端软件或IE阻止其运行.");
			}
				window.CertMgr = p11Ctrl;
		}
		return p11Ctrl;
	}

	//连接WebSocket
	function connect(){
		try{
			socket = new WebSocket(host);
			socket.onopen = function(){
				socket.send('0|'+  new Date().getTime());
			}
			socket.onclose = function(){
				alert("证书服务无法连接，请启动证书服务。");
			}
			socket.onmessage = function(msg){
				var args  = msg.data.split('|');
				if(args[0] == 0 && args[1].indexOf("Welcome")!=-1){
						//alert("证书服务连接成功！");
				}		
			}
		} catch(exception){
			alert('Error:'+exception);
		}
	}

	function UILogin(callback){
		if(isIE){
			try{
				var certB64 = cert.UILogin();
				callback();
			}catch(e){
				alert(e.message);
			}
		}else{
			var msgSend ='1|UILogin';
			socket.send(msgSend);
			socket.onmessage = function(msg){
				var args  = msg.data.split('|');
				if(args[1] == "UILogin"){
					var json = eval("("+args[2]+")"); 
					if(json.ret == 0){

					}else{
						alert(json.msg);
					}
				}		
			}
		}
	}

	owner.Sign = function(content, callback){
		if(isIE){
			try{
				var signature = signCert.SignText(content, 1);
				callback(signature);
			}catch(e){
				alert(e.message);
			}
		}else{
			var msgSend ='1|SignText|{"signText":"'+ content +'"}';
			socket.send(msgSend);
			socket.onmessage = function(msg){
				var args  = msg.data.split('|');
				if(args[1] == "SignText"){
					var json = eval("("+args[2]+")"); 
					if(json.ret == 0){
						var signature = json.signature;
						if(signature != ""){
							callback(signature);
						}
					}else{
						alert(json.msg);
					}
				}		
			}
		}
	}

	owner.SelectSignCert = function(){
		if(isIE){
			try {
				cert = signCert = CertMgr.SelectSignCert();
				//alert("选择证书完成！");
			}catch(e){
				alert(e.message);
				}
		}else{
			var msgSend ="1|SelectSignCert";
			socket.send(msgSend);
			socket.onmessage = function(msg){
				var args  = msg.data.split('|');
				if(args[1] == "SelectSignCert"){
					var json = eval("("+args[2]+")"); 
					if(json.ret == 0){
						//alert("选择证书完成！");
					}else{
						alert(json.msg);
					}
				}		
			}
		}
	}

	function SelectCryptCert(){
		if(isIE){
			try {
				cert = cryptCert = CertMgr.SelectEncryptCert();
				alert("选择证书完成！");
			}catch(e){
				alert(e.message);
				}
		}else{
			var msgSend ="1|SelectCryptCert";
			socket.send(msgSend);
			socket.onmessage = function(msg){
				var args  = msg.data.split('|');
				if(args[1] == "SelectCryptCert"){
					var json = eval("("+args[2]+")"); 
					if(json.ret == 0){
						alert("选择证书完成！");
					}else{
						alert(json.msg);
					}
				}		
			}
		}
	}

	function GetSubjectItem(index, callback){
		if(isIE){
			try{
				var content = cert.GetSubjectItem(index);
				callback(content);
			}catch(e){
				alert(e.message);
			}
		}else{
			var msgSend ='1|GetSubjectItem|{"index":'+ index +'}';
			socket.send(msgSend);
			socket.onmessage = function(msg){
				var args  = msg.data.split('|');
				if(args[1] == "GetSubjectItem"){
					var json = eval("("+args[2]+")"); 
					if(json.ret == 0){
						var content = json.content;
						if(content != ""){
							callback(content);
						}
					}else{
						alert(json.msg);
					}
				}		
			}
		}
	}

	owner.GetCertB64 = function(callback){
		if(isIE){
			try{
				var content = cert.GetCertB64();
				callback(content);
			}catch(e){
				alert(e.message);
			}
		}else{
			var msgSend ='1|GetCertB64';
			socket.send(msgSend);
			socket.onmessage = function(msg){
				var args  = msg.data.split('|');
				if(args[1] == "GetCertB64"){
					var json = eval("("+args[2]+")"); 
					if(json.ret == 0){
						var cert = json.cert;
						if(cert != ""){
							callback(cert);
						}
					}else{
						alert(json.msg);
					}
				}		
			}
		}
	}


	function GetCertCount(callback){
		if(isIE){
			try{
				var count = CertMgr.GetCertCount();
				callback(count);
			}catch(e){
				alert(e.message);
			}
		}else{
			var msgSend ='1|GetCertCount';
			socket.send(msgSend);
			socket.onmessage = function(msg){
				var args  = msg.data.split('|');
				if(args[1] == "GetCertCount"){
					var json = eval("("+args[2]+")"); 
					if(json.ret == 0){
						var count = json.count;
						callback(count);

					}else{
						alert(json.msg);
					}
				}		
			}
		}
	}

	function Encrypt(b64Data, callback){
		if(isIE){
			try{
				var encrypted = cryptCert.EncryptB64(b64Data);
				callback(encrypted);
			}catch(e){
				alert(e.message);
			}
		}else{
			var msgSend ='1|EncryptB64|{"b64data":"'+ b64Data +'"}';
			socket.send(msgSend);
			socket.onmessage = function(msg){
				var args  = msg.data.split('|');
				if(args[1] == "EncryptB64"){
					var json = eval("("+args[2]+")"); 
					if(json.ret == 0){
						var encrypted = json.b64encrypted;
						if(encrypted != ""){
							callback(encrypted);
						}
					}else{
						alert(json.msg);
					}
				}		
			}
		}
	}

	function Decrypt(b64Data, callback){
		if(isIE){
			try{
				var decrypted = cryptCert.DecryptB64(b64Data);
				callback(decrypted);
			}catch(e){
				alert(e.message);
			}
		}else{
			var msgSend ='1|DecryptB64|{"b64data":"'+ b64Data +'"}';
			socket.send(msgSend);
			socket.onmessage = function(msg){
				var args  = msg.data.split('|');
				if(args[1] == "DecryptB64"){
					var json = eval("("+args[2]+")"); 
					if(json.ret == 0){
						var decrypted = json.b64decrypted;
						if(decrypted != ""){
							callback(decrypted);
						}
					}else{
						alert(json.msg);
					}
				}		
			}
		}
	}

	function GenerateFileKeyB64(callback){
		if(isIE){
			try{
				var b64key = util.GenerateFileKeyB64();
				callback(b64key);
			}catch(e){
				alert(e.message);
			}
		}else{
			var msgSend ='1|GenerateFileKeyB64';
			socket.send(msgSend);
			socket.onmessage = function(msg){
				var args  = msg.data.split('|');
				if(args[1] == "GenerateFileKeyB64"){
					var json = eval("("+args[2]+")"); 
					if(json.ret == 0){
						var b64key = json.b64key;
						if(b64key != ""){
							callback(b64key);
						}
					}else{
						alert(json.msg);
					}
				}		
			}
		}
	}

	function EncryptFile(b64Data,srcPath, dstPath, callback){
		if(isIE){
			try{
				util.EncryptFile (b64Data, srcPath, dstPath);
				callback();
			}catch(e){
				alert(e.message);
			}
		}else{
			var msgSend ='1|EncryptFile|{"key":"'+ b64Data +'","src":"' + srcPath + '","dst":"' + dstPath + '"}';
			socket.send(msgSend);
			socket.onmessage = function(msg){
				var args  = msg.data.split('|');
				if(args[1] == "EncryptFile"){
					var json = eval("("+args[2]+")"); 
					if(json.ret == 0){
							callback();
					}else{
						alert(json.msg);
					}
				}		
			}
		}
	}

	function DecryptFile(b64Data,srcPath, dstPath, callback){
		if(isIE){
			try{
				util.DecryptFile (b64Data, srcPath, dstPath);
				callback();
			}catch(e){
				alert(e.message);
			}
		}else{
			var msgSend ='1|DecryptFile|{"key":"'+ b64Data +'","src":"' + srcPath + '","dst":"' + dstPath + '"}';
			socket.send(msgSend);
			socket.onmessage = function(msg){
				var args  = msg.data.split('|');
				if(args[1] == "DecryptFile"){
					var json = eval("("+args[2]+")"); 
					if(json.ret == 0){
							callback();
					}else{
						alert(json.msg);
					}
				}		
			}
		}
	}
		
		function P7Sign(b64Data, callback){
		if(isIE){
			try{
				pkcs7.SetSignCert(signCert);
				var signature = pkcs7.SignB64(0, b64Data, 4);
				callback(signature);
			}catch(e){
				alert(e.message);
			}
		}else{
			var msgSend ='1|P7SignB64|{"b64data":"'+ b64Data + '"}';
			socket.send(msgSend);
			socket.onmessage = function(msg){
				var args  = msg.data.split('|');
				if(args[1] == "P7SignB64"){
					var json = eval("("+args[2]+")"); 
					if(json.ret == 0){
						var signature = json.b64data;
						if(signature != ""){
							callback(signature);
						}
					}else{
						alert(json.msg);
					}
				}		
			}
		}
	}
		
			function P7VerifySign(b64Data, callback){
		if(isIE){
			try{
				var valid = pkcs7.VerifyB64(b64Data);
				callback(valid);
			}catch(e){
				alert(e.message);
			}
		}else{
			var msgSend ='1|P7VerifyB64|{"b64data":"'+ b64Data + '"}';
			socket.send(msgSend);
			socket.onmessage = function(msg){
				var args  = msg.data.split('|');
				if(args[1] == "P7VerifyB64"){
					var json = eval("("+args[2]+")"); 
					if(json.ret == 0){
						var valid = json.result;
							callback(valid);
					}else{
						alert(json.msg);
					}
				}		
			}
		}
	}
		
	function AddRecipient(b64Data, callback){
				if(isIE){
				try{
					var valid = pkcs7.AddRecipientCert(b64Data);	
				}catch(e){
					alert(e.message);
				}
			}
			recipientCerts.push( b64Data );
		}
		
	function ClearRecipient(callback){
			if(isIE){
				try{
					var valid = pkcs7.RemoveAllRecipientCert();
				}catch(e){
					alert(e.message);
				}
			}
			recipientCerts = [];
		}
		
		
	function Cert2Json()
	{
		if( recipientCerts.length < 1 )
				return "";
		var result="";
		result = '"certs":[';
		
		
		for(var i=0;i<recipientCerts.length;i++){
				result += '{"cert":"';
				result += recipientCerts[i];
				result += '"}';
				if( i != (recipientCerts.length-1))
						result += ',';
		}
		result += ']';
		return result;

	}

		
			function P7Envelop(b64Data, callback){
		if(isIE){
			try{
				var signature = pkcs7.EnvelopB64(b64Data, 0);
				callback(signature);
			}catch(e){
				alert(e.message);
			}
		}else{
			var certs = Cert2Json();
			if( certs == "" )
			{
					alert("请添加接收者证书");
			}
			var msgSend ='1|EnvelopB64|{"b64data":"'+ b64Data + '",' + certs + '}';
			socket.send(msgSend);
			socket.onmessage = function(msg){
				var args  = msg.data.split('|');
				if(args[1] == "EnvelopB64"){
					var json = eval("("+args[2]+")"); 
					if(json.ret == 0){
						var signature = json.b64data;
						if(signature != ""){
							callback(signature);
						}
					}else{
						alert(json.msg);
					}
				}		
			}
		}
	}
		
			
			function P7UnEnvelop(b64Data, callback){
		if(isIE){
			try{
				cert = cryptCert = CertMgr.SelectEncryptCert();
				pkcs7.SetUnEnvelopCert(cryptCert);
				var signature = pkcs7.UnEnvelopB64(b64Data);
				callback(signature);
			}catch(e){
				alert(e.message);
			}
		}else{
			var msgSend ='1|UnEnvelopB64|{"b64data":"'+ b64Data + '"}';
			socket.send(msgSend);
			socket.onmessage = function(msg){
				var args  = msg.data.split('|');
				if(args[1] == "UnEnvelopB64"){
					var json = eval("("+args[2]+")"); 
					if(json.ret == 0){
						var signature = json.b64data;
						if(signature != ""){
							callback(signature);
						}
						}
						else{
						alert(json.msg);
					}
				}		
			}
		}
	}
		
		
				function IsCertOnline(cn, callback){
		if(isIE){
			try{
				var count = CertMgr.GetCertCount();
				var online = 0;
				for(var i=0;i<count;i++)
				{
					var c = CertMgr.GetCert(i);
					var tempCN = c.GetSubjectItem(0);
					if( cn == tempCN )
					{
						online = 1;
						break;
					}
				}
				callback(online);
			}catch(e){
				alert(e.message);
			}
		}else{
			var msgSend ='1|IsCertOnline|{"cn":"'+ cn + '"}';
			socket.send(msgSend);
			socket.onmessage = function(msg){
				var args  = msg.data.split('|');
				if(args[1] == "IsCertOnline"){
					var json = eval("("+args[2]+")"); 
					if(json.ret == 0){
						var valid = json.result;
							callback(valid);
					}else{
						alert(json.msg);
					}
				}		
			}
		}
	}
		
		function SignB64(content, callback){
		if(isIE){
			try{
				var signature = signCert.SignB64(content, 1);
				callback(signature);
			}catch(e){
				alert(e.message);
			}
		}else{
			var msgSend ='1|SignB64|{"b64data":"'+ content +'"}';
			socket.send(msgSend);
			socket.onmessage = function(msg){
				var args  = msg.data.split('|');
				if(args[1] == "SignB64"){
					var json = eval("("+args[2]+")"); 
					if(json.ret == 0){
						var signature = json.signature;
						if(signature != ""){
							callback(signature);
						}
					}else{
						alert(json.msg);
					}
				}		
			}
		}
	}

	function GetSignCertCount(callback){
		if(isIE){
			try{
				var count = CertMgr.GetSignCertCount();
				callback(count);
			}catch(e){
				alert(e.message);
			}
		}else{
			var msgSend ='1|GetSignCertCount';
			socket.send(msgSend);
			socket.onmessage = function(msg){
				var args  = msg.data.split('|');
				if(args[1] == "GetSignCertCount"){
					var json = eval("("+args[2]+")"); 
					if(json.ret == 0){
						var count = json.count;
						callback(count);

					}else{
						alert(json.msg);
					}
				}		
			}
		}
	}

	function Login(pin, callback){
		if(isIE){
			try{
				signCert.Login(pin);
				callback();
			}catch(e){
				alert(e.message);
			}
		}else{
			var msgSend ='1|Login|{"pin":"'+ pin +'"}';
			socket.send(msgSend);
			socket.onmessage = function(msg){
				var args  = msg.data.split('|');
				if(args[1] == "Login"){
					var json = eval("("+args[2]+")"); 
					if(json.ret == 0){
						callback();
					}else{
						alert(json.msg);
					}
				}		
			}
		}
	}

	owner.GetSignCertNotAfter = function(certIndex, callback){
		if(isIE){
			try{
				var signCert = CertMgr.GetSignCert(certIndex);
				var dateNotAfter =  signCert.NotAfter;
				callback(dateNotAfter);
			}catch(e){
				alert(e.message);
			}
		}else{
			var msgSend ='1|GetSignCertNotAfter|{"index":'+ certIndex +'}';
			socket.send(msgSend);
			socket.onmessage = function(msg){
				var args  = msg.data.split('|');
				if(args[1] == "GetSignCertNotAfter"){
					var json = eval("("+args[2]+")"); 
					if(json.ret == 0){
						var dateNotAfter = json.certnotafter;
						callback(dateNotAfter);

					}else{
						alert(json.msg);
					}
				}		
			}
		}
	}

	function ReadRegB64(key, name, callback){
		if(isIE){
			try{
				var value = util.ReadRegB64(key, name);
				callback(value);
			}catch(e){
				alert(e.message);
			}
		}else{
			var msgSend ='1|ReadRegB64|{"key":"'+ key + '","name":"' + name + '"}';
			socket.send(msgSend);
			socket.onmessage = function(msg){
				var args  = msg.data.split('|');
				if(args[1] == "ReadRegB64"){
					var json = eval("("+args[2]+")"); 
					if(json.ret == 0){
						var value = json.value;
						callback(value);

					}else{
						alert(json.msg);
					}
				}		
			}
		}
	}

	function WriteRegStringB64(key, name, value, callback){
		if(isIE){
			try{
				util.WriteRegB64(key, name, value);
				callback();
			}catch(e){
				alert(e.message);
			}
		}else{
			var msgSend ='1|WriteRegB64|{"key":"'+ key + '","name":"' + name + '","value":"' + value + '"}';
			socket.send(msgSend);
			socket.onmessage = function(msg){
				var args  = msg.data.split('|');
				if(args[1] == "WriteRegB64"){
					var json = eval("("+args[2]+")"); 
					if(json.ret == 0){
						callback();

					}else{
						alert(json.msg);
					}
				}		
			}
		}
	}

	function WriteRegIntB64(key, name, value, callback){
		if(isIE){
			try{
				util.WriteRegB64(key, name, value);
				callback();
			}catch(e){
				alert(e.message);
			}
		}else{
			var msgSend ='1|WriteRegB64|{"key":"'+ key + '","name":"' + name + '","value":' + value + '}';
			socket.send(msgSend);
			socket.onmessage = function(msg){
				var args  = msg.data.split('|');
				if(args[1] == "WriteRegB64"){
					var json = eval("("+args[2]+")"); 
					if(json.ret == 0){
						callback();

					}else{
						alert(json.msg);
					}
				}		
			}
		}
	}

	function WriteDataB64(name, data, isprivate, callback){
		if(isIE){
			try{
				cert.Device.WriteDataB64(name, data, isprivate);
				callback();
			}catch(e){
				alert(e.message);
			}
		}else{
			var msgSend ='1|WriteDataB64|{"name":"'+ name + '","b64data":"' + data + '","isprivate":' + isprivate + '}';
			socket.send(msgSend);
			socket.onmessage = function(msg){
				var args  = msg.data.split('|');
				if(args[1] == "WriteDataB64"){
					var json = eval("("+args[2]+")"); 
					if(json.ret == 0){
						callback();

					}else{
						alert(json.msg);
					}
				}		
			}
		}
	}

	function ReadDataB64(name, callback){
		if(isIE){
			try{
				var data = cert.Device.WriteDataB64(name);
				callback(data);
			}catch(e){
				alert(e.message);
			}
		}else{
			var msgSend ='1|ReadDataB64|{"name":"'+ name + '"}';
			socket.send(msgSend);
			socket.onmessage = function(msg){
				var args  = msg.data.split('|');
				if(args[1] == "ReadDataB64"){
					var json = eval("("+args[2]+")"); 
					if(json.ret == 0){
						var b64data = json.b64data;
						callback(b64data);

					}else{
						alert(json.msg);
					}
				}		
			}
		}
	}

				function IsCertLogined(cn, callback){
		if(isIE){
			try{
				var count = CertMgr.GetCertCount();
				var online = 0;
				for(var i=0;i<count;i++)
				{
					var c = CertMgr.GetCert(i);
					var tempCN = c.GetSubjectItem(0);
					if( cn == tempCN )
					{
						online = c.Logined();
						if( online )
							break;
					}
				}
				callback(online);
			}catch(e){
				alert(e.message);
			}
		}else{
			var msgSend ='1|IsCertLogined|{"cn":"'+ cn + '"}';
			socket.send(msgSend);
			socket.onmessage = function(msg){
				var args  = msg.data.split('|');
				if(args[1] == "IsCertLogined"){
					var json = eval("("+args[2]+")"); 
					if(json.ret == 0){
						var valid = json.result;
							callback(valid);
					}else{
						alert(json.msg);
					}
				}		
			}
		}
	}

	function Logout(callback){
		if(isIE){
			try{
				signCert.Logout();
				callback();
			}catch(e){
				alert(e.message);
			}
		}else{
			var msgSend ='1|Logout';
			socket.send(msgSend);
			socket.onmessage = function(msg){
				var args  = msg.data.split('|');
				if(args[1] == "Logout"){
					var json = eval("("+args[2]+")"); 
					if(json.ret == 0){
						callback();
					}else{
						alert(json.msg);
					}
				}		
			}
		}
	}

})(Vue.prototype)

